export function getGradientColor(progress) {
  let r;
  let g;
  let b;

  if (progress < 0.5) {
    // Yellow-green to orange
    const t = progress / 0.5;
    r = Math.round(170 + (255 - 170) * t);
    g = Math.round(238 + (102 - 238) * t);
    b = 0;
  } else {
    // Orange to deep red
    const t = (progress - 0.5) / 0.5;
    r = Math.round(255 + (187 - 255) * t);
    g = Math.round(102 * (1 - t));
    b = 0;
  }

  return `rgb(${r}, ${g}, ${b})`;
}
